import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { cn } from '@/lib/utils';
    import { DropdownMenuSeparator, type DropdownMenuSeparatorProps } from 'reka-ui';
    import { computed, reactive, type HTMLAttributes } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownMenuSeparator',
  props: {
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] },
    class: {}
  },
  setup(__props: any) {

    const props = __props;

    const delegatedProps = computed(() => {
        const { class: _, ...delegated } = props;

        return reactive(delegated);
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DropdownMenuSeparator), _mergeProps({ "data-slot": "dropdown-menu-separator" }, delegatedProps.value, {
    class: _unref(cn)('bg-border -mx-1 my-1 h-px', props.class)
  }), null, 16, ["class"]))
}
}

})